import React from "react";

import type { AuditEntitySlug } from "./auditTypes";
import ActionLink from "../controls/ActionLink";
import {
  AUDIT_HISTORIES_LINK_LABEL,
  AUDIT_HISTORIES_LINK_REL,
  AUDIT_HISTORIES_LINK_TARGET,
  buildAuditHistoriesUrl,
} from "./auditEntityConfig";

type AuditHistoriesLinkProps = {
  slug: AuditEntitySlug;
  className?: string;
};

export default function AuditHistoriesLink({
  slug,
  className = "",
}: AuditHistoriesLinkProps) {
  return (
    <ActionLink
      variant="secondary"
      to={buildAuditHistoriesUrl(slug)}
      target={AUDIT_HISTORIES_LINK_TARGET}
      rel={AUDIT_HISTORIES_LINK_REL}
      className={`h-10 min-w-0 ${className}`.trim()}
    >
      {AUDIT_HISTORIES_LINK_LABEL}
    </ActionLink>
  );
}
